// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__3tSzE","form":"style_form__1pDk3","button":"style_button__23zWJ"};